module.exports = __webpack_public_path__ + "static/img/cert10.3b7e865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert10.png
// module id = EVxU
// module chunks = 52